import { PortableText } from "@portabletext/react";
import { Link, graphql } from "gatsby";
import { Link as LinkScroll } from "react-scroll";
import React from "react";
import PageBannerTwo from "../components/PageBannerTwo";
import SEO from "../components/SEO";
import Contact from "../components/blog/Contact";
import RecentCard from "../components/blog/RecentCard";
import BuilderContent from "../components/pagebuilder/content";
import BuilderBanner from "../components/pagebuilder/banner";

const BlogDetails = ({ pageContext, data: { sanityPageBuilder } }) => {
  const { categories, tags, blog } = pageContext;
  //   const contact = sanityBlogPage?.contact;
  //   const author = blog?.author;

  const parseURL = (ref) => {
    if (ref) {
      const split = ref.split("-");

      if (split.length === 4) {
        return `https://cdn.sanity.io/images/nhbs99kp/production/${split[1]}-${split[2]}.${split[3]}`;
      }
      return "";
    } else {
      return "";
    }
  };

  const _renderSection = (item, key) => {
    const { _type } = item;
    switch (_type) {
      case "builderContent":
        return <BuilderContent data={item} enable={key === 0} key={key} />;
      case "builderBanner":
        return <BuilderBanner data={item} key={key} />;

      default:
        return null;
    }
  };

  return (
    <>
      <PageBannerTwo
        image={sanityPageBuilder?.hero}
        heading={sanityPageBuilder?.title}
        button={sanityPageBuilder?.button}
      />
      <section className="blog-details-page pt-80 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-7">
              <div className="blog-details-wrapper mb-[40px] wow fadeInUp">
                <div className="blog-post-item">
                  {sanityPageBuilder.pageSections.map((item, index) =>
                    _renderSection(item, index)
                  )}
                  {/* {sanityPageBuilder.pageSections.map((pageSection) => (
                    <div className="post-content">
                      {blog?._rawBody && (
                        <PortableText
                          value={blog?._rawBody}
                          components={{
                            marks: {
                              color: ({ value, children }) => (
                                <span style={{ color: value.hex }}>
                                  {children}
                                </span>
                              ),
                              link: ({ value, children }) => {
                                const target = (value?.href || "").startsWith(
                                  "http"
                                )
                                  ? "_blank"
                                  : undefined;
                                return (
                                  <a
                                    href={value?.href}
                                    target={target}
                                    rel={
                                      target === "_blank" && "noindex nofollow"
                                    }
                                    className="underline transition-colors duration-150 ease-linear underline-offset-8 hover:text-primary"
                                  >
                                    {children}
                                  </a>
                                );
                              },
                            },
                            types: {
                              figure: ({ value }) => {
                                return (
                                  <div className="img-container">
                                    <img
                                      src={parseURL(value?.asset?._ref)}
                                      alt={value?.alt}
                                    />
                                  </div>
                                );
                              },
                              banner: ({ value }) => {
                                return (
                                  <div className="banner">
                                    <h1>{value.heading}</h1>
                                    {value?.subheading && (
                                      <h2>{value.subheading}</h2>
                                    )}
                                  </div>
                                );
                              },
                            },
                          }}
                        />
                      )}

                      <br />
                      <div className="post-share-tag mb-[40px]">
                      <div className="row">
                        <div className="col-12">
                          <div className="post-tag-cloud">
                            <ul>
                              <li className="item-heading">Tags :</li>
                              {blog?.tag.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <Link to={`/tag/${item?.slug?.current}`}>
                                      {item.name}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="post-author-box d-flex mb-80">
                      <div className="author-thumb">
                        <img
                          src={author?.photo?.asset?.url}
                          alt="post author"
                        />
                      </div>
                      <div className="author-content">
                        <h4>{author?.name}</h4>
                        <p>{author?.Bio}</p>
                      </div>
                    </div>
                    </div>
                  ))} */}
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-5">
              <div
                className="sidebar-widget-area"
                style={{
                  position: "sticky",
                  top: "142px",
                }}
              >
                <div className="widget category-widget mb-[40px] wow fadeInUp">
                  <h4 className="widget-title">Table of Contents</h4>
                  <ul className="category-nav">
                    {sanityPageBuilder.tableOfContents?.map(
                      (tableofcontent, index) => {
                        return (
                          <li key={index}>
                            <LinkScroll
                              className="cursor-pointer"
                              to={tableofcontent.sectionId}
                              offset={-142}
                            >
                              {tableofcontent.title}
                              <span>
                                <i className="far fa-arrow-right" />
                              </span>
                            </LinkScroll>
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
                {/* <Contact data={contact} />
                <div className="widget recent-post-widget mb-[40px] wow fadeInUp">
                  <h4 className="widget-title">Recent News</h4>
                  <ul className="recent-post-list">
                    {recentNews.edges?.slice(0, 3).map(({ node }, index) => (
                      <RecentCard data={node} key={index} />
                    ))}
                  </ul>
                </div>
                <div className="widget tag-cloud-widget mb-[40px] wow fadeInUp">
                  <h4 className="widget-title">Popular Tags</h4>
                  {tags?.map((item, index) => {
                    return (
                      <Link to={`/tag/${item.slug.current}`} key={index}>
                        {item?.name}
                      </Link>
                    );
                  })}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export const query = graphql`
  query ($slug: String!) {
    sanityPageBuilder(pageSlug: { current: { eq: $slug } }) {
      pageTitle
      seo {
        title
        description
        keywords
        ldSchema
      }
      hero {
        asset {
          url
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            formats: [WEBP, AUTO]
          )
        }
      }
      title
      button {
        btnType
        linkType
        title
        link
      }
      tableOfContents {
        sectionId
        title
      }
      pageSections {
        ... on SanityBuilderContent {
          _type
          sectionId
          heading
          headingColor {
            hex
          }
          subheading
          subheadingColor {
            hex
          }
          _rawDescription
          descriptionColor {
            hex
          }
          image {
            title
            iconImage {
              asset {
                gatsbyImageData(
                  layout: CONSTRAINED
                  formats: WEBP
                  placeholder: BLURRED
                )
              }
            }
          }
          button {
            btnType
            linkType
            title
            link
          }
        }
        ... on SanityBuilderBanner {
          _type
          sectionId
          heading
          headingColor {
            hex
          }
          subheading
          subheadingColor {
            hex
          }
          image {
            title
            iconImage {
              asset {
                gatsbyImageData(
                  layout: CONSTRAINED
                  formats: WEBP
                  placeholder: BLURRED
                )
              }
            }
          }
          button {
            btnType
            linkType
            title
            link
          }
        }
      }
    }
    sanitySitesettings {
      favicon {
        asset {
          url
        }
      }
    }
  }
`;

export default BlogDetails;

export function Head({ location, data }) {
  return (
    <SEO
      location={location}
      data={data.sanityPageBuilder?.seo}
      favicon={data?.sanitySitesettings?.favicon}
    />
  );
}
